import { render, staticRenderFns } from "./changeTPwdDc.vue?vue&type=template&id=5fa2166b&scoped=true"
import script from "./changeTPwdDc.vue?vue&type=script&lang=js"
export * from "./changeTPwdDc.vue?vue&type=script&lang=js"
import style0 from "./changeTPwdDc.vue?vue&type=style&index=0&id=5fa2166b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa2166b",
  null
  
)

export default component.exports